import { render, staticRenderFns } from "./NewGrowthProgramModal.vue?vue&type=template&id=451a855c&"
import script from "./NewGrowthProgramModal.vue?vue&type=script&lang=js&"
export * from "./NewGrowthProgramModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports